import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { MailIcon, LinkedinIcon, TwitterIcon } from 'lucide-react';
// This data would ideally come from a CMS or API
const teamMembersData = {
  'alfred-chuang': {
    name: 'Alfred Chuang',
    title: 'General Partner',
    image: 'https://cdn.prod.website-files.com/62e0202ed964cdb8b5ad3acd/62e0202ed964cd704aad3b33_1590614887781.jpeg',
    bio: `Alfred Chuang is a General Partner at Race Capital, bringing decades of experience as a technology entrepreneur and executive. As the founder and CEO of BEA Systems, Alfred led the company from its inception to its acquisition by Oracle for $8.5 billion.
    Prior to Race Capital, Alfred founded and served as CEO of Magnet Systems, a platform for building and deploying enterprise mobile applications. His deep expertise in enterprise software and infrastructure has made him a trusted advisor to numerous founders building the next generation of technology companies.
    Alfred's technical background and operational experience give him unique insights into the challenges that founders face when scaling their businesses. He is passionate about helping entrepreneurs navigate these challenges and build category-defining companies.`,
    social: {
      email: 'alfred@race.capital',
      linkedin: 'https://www.linkedin.com/in/alchuang/',
      twitter: 'https://twitter.com/chuang_alfred?lang=en-GB'
    }
  },
  'bernard-chan': {
    name: 'Bernard Chan',
    title: 'Investor',
    image: 'https://cdn.prod.website-files.com/62e0202ed964cdb8b5ad3acd/67e17e811118b5f0ccc4a399_Bernard%20Profile.png',
    bio: `Bernard Chan is an Investor at Race Capital, where he focuses on identifying and supporting promising early-stage startups in enterprise software, infrastructure, and fintech.
    With a background in technology and finance, Bernard brings valuable insights to founders navigating the challenges of building and scaling their businesses. He works closely with portfolio companies to help them refine their strategies and achieve their growth objectives.
    Bernard is passionate about innovation and is committed to partnering with entrepreneurs who are building transformative solutions to complex problems.`,
    social: {
      email: 'bernard@race.capital',
      linkedin: 'https://www.linkedin.com/in/bernard-chan-cl/',
      twitter: 'https://twitter.com/bernardchancl'
    }
  },
  'chris-mccann': {
    name: 'Chris McCann',
    title: 'General Partner',
    image: 'https://uploads-ssl.webflow.com/62e0202ed964cdb8b5ad3acd/62e0202ed964cd1395ad3bae_Chris.png',
    bio: `Chris McCann is a General Partner at Race Capital, where he leverages his extensive experience as an entrepreneur and investor to identify and support promising startups.
    Prior to joining Race Capital, Chris founded and led several successful technology companies and worked with numerous startups as an advisor and investor. His operational background gives him a deep understanding of the challenges that founders face when building and scaling their businesses.
    Chris is particularly interested in companies at the intersection of consumer technology, enterprise software, and infrastructure. He is committed to being a hands-on partner to founders, providing both strategic guidance and tactical support.`,
    social: {
      email: 'chris@race.capital',
      linkedin: 'https://www.linkedin.com/in/mccannatron/',
      twitter: 'https://twitter.com/mccannatron'
    }
  },
  'edith-yeung': {
    name: 'Edith Yeung',
    title: 'General Partner',
    image: 'https://uploads-ssl.webflow.com/62e0202ed964cdb8b5ad3acd/62e0202ed964cd85dead3b1d_1611126496277.jpeg',
    bio: `Edith Yeung is a General Partner at Race Capital, focusing on investments in AI, infrastructure, and mobile technology. With over 20 years of experience in the technology industry, Edith brings valuable insights and connections to the founders she works with.
    Before joining Race Capital, Edith was a General Partner at 500 Startups, where she led investments in over 50 startups. She has also held executive roles at Dolphin Browser and Sequoia Capital, giving her a comprehensive understanding of both operational and investment aspects of the technology ecosystem.
    Edith is passionate about supporting founders who are building transformative technologies and is committed to helping them navigate the challenges of scaling their businesses.`,
    social: {
      email: 'edith@race.capital',
      linkedin: 'https://www.linkedin.com/in/edithyeung/',
      twitter: 'https://twitter.com/edithyeung'
    }
  },
  'elizabeth-candelaria': {
    name: 'Elizabeth Candelaria',
    title: 'Senior EA & Office Manager',
    image: 'https://cdn.prod.website-files.com/62e0202ed964cdb8b5ad3acd/6501d75a036f656d0f3a3c6a_62e0202ed964cd8da9ad3b7f_Elizabeth-Candelaria-small.jpeg',
    bio: `Elizabeth (Liz) Candelaria is the Senior Executive Assistant and Office Manager at Race Capital, where she ensures the smooth operation of the firm's day-to-day activities and supports the team in their work with portfolio companies.
    With extensive experience in administrative and operational roles, Liz brings exceptional organizational skills and attention to detail to her position. She plays a crucial role in maintaining the efficiency and effectiveness of Race Capital's operations.
    Liz is dedicated to creating a supportive environment for both the Race Capital team and the founders they work with, contributing to the firm's mission of helping entrepreneurs build market-transforming companies.`,
    social: {
      email: 'liz@race.capital',
      linkedin: 'https://www.linkedin.com/in/liz-vera-7743b16/',
      twitter: ''
    }
  },
  'kelly-cheng': {
    name: 'Kelly Cheng',
    title: 'CFO',
    image: 'https://cdn.prod.website-files.com/62e0202ed964cdb8b5ad3acd/670e90e438f68b665e0edbe5_Untitled.png',
    bio: `Kelly Cheng is the Chief Financial Officer at Race Capital, where she oversees the firm's financial strategy and operations. With a strong background in finance and accounting, Kelly brings valuable expertise to the team.
    Prior to joining Race Capital, Kelly held senior financial roles at various investment firms and technology companies, giving her a deep understanding of both the financial and operational aspects of venture capital and startups.
    Kelly works closely with the Race Capital team and portfolio companies to ensure sound financial management and strategic decision-making. Her expertise is instrumental in helping the firm navigate complex financial landscapes and maximize value for investors and portfolio companies alike.`,
    social: {
      email: 'kelly@race.capital',
      linkedin: 'http://www.linkedin.com/in/kbcheng',
      twitter: ''
    }
  },
  'matt-mclaughlin': {
    name: 'Matt McLaughlin',
    title: 'Senior Operating Partner',
    image: 'https://cdn.prod.website-files.com/62e0202ed964cdb8b5ad3acd/67812d6064cbde074e7c95ca_Untitled.png',
    bio: `Matt McLaughlin is the Senior Operating Partner at Race Capital, where he works closely with portfolio companies to help them optimize their operations and accelerate their growth.
    With extensive experience in scaling technology companies, Matt brings valuable operational expertise to founders navigating the challenges of building and growing their businesses. He has a proven track record of helping companies improve their efficiency, effectiveness, and overall performance.
    Matt is passionate about helping entrepreneurs turn their visions into reality and is committed to being a hands-on partner throughout their journey. His strategic guidance and practical support are invaluable resources for Race Capital's portfolio companies.`,
    social: {
      email: 'matt@race.capital',
      linkedin: 'https://www.linkedin.com/in/mwmgtm/',
      twitter: ''
    }
  },
  'mohak-saxena': {
    name: 'Mohak Saxena',
    title: 'Investor',
    image: 'https://cdn.prod.website-files.com/62e0202ed964cdb8b5ad3acd/674ddd11189fcab109c08bf5_Screenshot%202024-12-02%20at%204.15.10%E2%80%AFPM.png',
    bio: `Mohak Saxena is an Investor at Race Capital, where he focuses on identifying and supporting promising early-stage startups in enterprise software, infrastructure, and emerging technologies.
    With a background in technology and finance, Mohak brings a unique perspective to evaluating investment opportunities and supporting portfolio companies. He works closely with founders to help them refine their strategies, overcome challenges, and achieve their growth objectives.
    Mohak is passionate about innovation and is committed to partnering with entrepreneurs who are building transformative solutions to complex problems. He is particularly interested in companies leveraging cutting-edge technologies to create new markets or disrupt existing ones.`,
    social: {
      email: 'mohak@race.capital',
      linkedin: 'https://www.linkedin.com/in/mohak-saxena',
      twitter: ''
    }
  },
  'nick-dane': {
    name: 'Nick Dane',
    title: 'Capital Formation & IR',
    image: 'https://cdn.prod.website-files.com/62e0202ed964cdb8b5ad3acd/686ffac2c7ff3b519ea30cb7_ND%20PP.png',
    bio: `Nick Dane leads Capital Formation and Investor Relations at Race Capital, where he is responsible for managing relationships with the firm's limited partners and expanding its investor base.
    With extensive experience in fundraising and investor relations, Nick brings valuable expertise to Race Capital's capital formation strategy. He works closely with the firm's partners to communicate Race Capital's investment thesis, performance, and value proposition to current and prospective investors.
    Nick is committed to maintaining transparent and productive relationships with Race Capital's limited partners, ensuring that they remain informed and engaged with the firm's activities and investments.`,
    social: {
      email: 'nick@race.capital',
      linkedin: 'http://www.linkedin.com/in/nickdane/',
      twitter: ''
    }
  },
  'tony-wong': {
    name: 'Tony Wong',
    title: 'EIR',
    image: 'https://cdn.prod.website-files.com/62e0202ed964cdb8b5ad3acd/651183f281964b9002aab8db_Tony-Wong-EIR.png',
    bio: `Tony Wong is an Entrepreneur in Residence (EIR) at Race Capital, where he leverages his experience as a founder and operator to support portfolio companies and explore new investment opportunities.
    With a background in building and scaling technology companies, Tony brings valuable insights to founders navigating the challenges of early-stage growth. He works closely with the Race Capital team to evaluate potential investments and provide strategic guidance to portfolio companies.
    Tony is passionate about innovation and entrepreneurship, and is committed to helping founders turn their visions into successful businesses. His practical experience and strategic thinking make him a valuable resource for entrepreneurs in the Race Capital ecosystem.`,
    social: {
      email: 'tony@race.capital',
      linkedin: 'https://www.linkedin.com/in/tonywongk/?originalSubdomain=hk',
      twitter: 'https://twitter.com/tonywongk'
    }
  }
};
export const TeamMemberPage = () => {
  const {
    slug
  } = useParams();
  const member = teamMembersData[slug];
  if (!member) {
    return <div className="w-full py-20 px-6 md:px-12 bg-white text-center" data-id="element-157">
        <div className="max-w-7xl mx-auto" data-id="element-158">
          <h1 className="text-4xl md:text-6xl font-bold text-black leading-tight mb-8" data-id="element-159">
            Team Member Not Found
          </h1>
          <Link to="/team" className="text-red-600 hover:text-red-700 font-medium" data-id="element-160">
            Return to Team Page
          </Link>
        </div>
      </div>;
  }
  return <div className="w-full bg-white" data-id="element-161">
      {/* Hero Section */}
      <section className="w-full py-20 px-6 md:px-12 bg-white" data-id="element-162">
        <div className="max-w-7xl mx-auto" data-id="element-163">
          <div className="flex flex-col md:flex-row items-start gap-12" data-id="element-164">
            <div className="w-full md:w-1/3" data-id="element-165">
              <div className="relative aspect-square overflow-hidden rounded-lg bg-gray-100" data-id="element-166">
                <img src={member.image} alt={member.name} className="w-full h-full object-cover" data-id="element-167" />
              </div>
              {/* Social Links */}
              <div className="flex items-center space-x-6 mt-6" data-id="element-168">
                <a href={`mailto:${member.social.email}`} aria-label="Email" className="text-red-600 hover:text-red-700 transition-colors" data-id="element-169">
                  <MailIcon size={28} data-id="element-170" />
                </a>
                {member.social.linkedin && <a href={member.social.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="text-red-600 hover:text-red-700 transition-colors" data-id="element-171">
                    <LinkedinIcon size={28} data-id="element-172" />
                  </a>}
                {member.social.twitter && <a href={member.social.twitter} target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="text-red-600 hover:text-red-700 transition-colors" data-id="element-173">
                    <TwitterIcon size={28} data-id="element-174" />
                  </a>}
              </div>
            </div>
            <div className="w-full md:w-2/3" data-id="element-175">
              <div className="flex items-center mb-6" data-id="element-176">
                <Link to="/team" className="text-red-600 hover:text-red-700 font-medium flex items-center" data-id="element-177">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-178">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" data-id="element-179" />
                  </svg>
                  Back to Team
                </Link>
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-[#070707] leading-tight mb-2" data-id="element-180">
                {member.name}
              </h1>
              <p className="text-xl text-red-600 font-medium mb-8" data-id="element-181">
                {member.title}
              </p>
              <div className="prose max-w-none" data-id="element-182">
                {member.bio.split('\n\n').map((paragraph, index) => <p key={index} className="text-[#070707] mb-4" data-id="element-183">
                    {paragraph}
                  </p>)}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
};